// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_c1-0";
export var orangeButton = "_c1-1";